import moment from 'moment'

// fill this api keys for Playground display WMS requests
const SENTINEL_1 = '6bd02175-d021-4a34-94d9-bc44c5897ddc'
const SENTINEL_2_L2A = '5a44cd8f-02f1-4cf0-afb8-f11fa46bfaee'
const SENTINEL_2_L1C = '5a44cd8f-02f1-4cf0-afb8-f11fa46bfaee'
const SENTINEL_3 = 'e144d6de-16fa-4c83-84c0-f74ddd0b0843'
const SENTINEL_5 = '389dc880-d54b-4f78-8e29-1c30a320533e'
const LANDSAT_8_API_KEY = '' //'d1951594-daea-42dc-8d51-203014edc660'
const DEM_API_KEY = ''
const MODIS_API_KEY = ''//'eb44b4ab-f98b-4511-824f-c5068e04a8a3'
const WILDFIRES = 'ba455c71-5a0e-4124-a0fc-3a981c6cf65f'
const FLOODING = 'e69541cf-65a0-4037-a684-69b857e1b152'

const DATASOURCES = [
  {
    url: `https://climateacademy.gr/playground/proxy.php?type=SENTINEL_2_L2A`,
    urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L2A}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
    minDate: '2017-03-28',
    id: 'DSS2',
    datasourceID: 'S2L2A',
    name: 'Sentinel-2 L2A',
    typeNames: 'DSS2',
    min: 9
  },
  // {
  //   url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L1C}`,
  //   urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L1C}`,
  //   index: 'http://services.sentinel-hub.com/index/v3/collections/S2L1C/searchIndex',
  //   minDate: '2015-01-01',
  //   id: 'S2.TILE',
  //   datasourceID: 'S2L1C',
  //   name: 'Sentinel-2 L1C',
  //   typeNames: 'S2.TILE'
  // },
  // {
  //   url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_1}`,
  //   minDate: '2014-04-03',
  //   index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
  //   id: 'S1',
  //   name: 'Sentinel-1'
  // },
  // {
  //   url: `https://creodias.sentinel-hub.com/ogc/wms/${SENTINEL_3}`,
  //   minDate: '2014-04-03',
  //   index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
  //   id: 'S3',
  //   name: 'Sentinel-3'
  // },
  // {
  //   url: `https://creodias.sentinel-hub.com/ogc/wms/${SENTINEL_5}`,
  //   index: 'https://creodias.sentinel-hub.com/index/v3/collections/S5PL2/searchIndex',
  //   minDate: '2020-01-01',
  //   id: 'S5',
  //   name: 'Sentinel-5P'
  // },
  // {
  //   url: `https://services-uswest2.sentinel-hub.com/v1/wms/${LANDSAT_8_API_KEY}`,
  //   index: 'https://services-uswest2.sentinel-hub.com/index/v3/collections/L8L1C/searchIndex',
  //   minDate: '2013-01-01',
  //   id: 'L8',
  //   datasourceID: 'L8L1C',
  //   name: 'Landsat 8',
  //   min: 10,
  //   typeNames: 'DSS6'
  // },
  // {
  //   url: `https://services-uswest2.sentinel-hub.com/v1/wms/${DEM_API_KEY}`,
  //   index: 'https://services-uswest2.sentinel-hub.com/index/v3/collections/DEM/searchIndex',
  //   minDate: '2013-01-01',
  //   id: 'DEM',
  //   name: 'DEM',
  //   datasourceID: 'DEM',
  //   min: 2,
  //   typeNames: 'DSS4'
  // },
  // {
  //   url: `https://services-uswest2.sentinel-hub.com/v1/wms/${MODIS_API_KEY}`,
  //   index: 'https://services-uswest2.sentinel-hub.com/index/modis/v2/',
  //   minDate: '2013-01-01',
  //   id: 'Modis',
  //   noEffects: true,
  //   name: 'MODIS',
  //   datasourceID: 'MODIS',
  //   min: 7,
  //   typeNames: 'DSS5'
  // },
  // {
  //   url: `https://services.sentinel-hub.com/ogc/wms/${FLOODING}`,
  //   urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${FLOODING}`,
  //   index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
  //   minDate: '2017-03-28',
  //   id: 'FLOODING',
  //   datasourceID: 'S2L2A',
  //   name: 'FLOODING',
  //   typeNames: 'DSS2',
  //   min: 9
  // },
  // {
  //   url: `https://services.sentinel-hub.com/ogc/wms/${WILDFIRES}`,
  //   urlProcessingApi: `https://services.sentinel-hub.com/ogc/wms/${WILDFIRES}`,
  //   index: 'http://services.sentinel-hub.com/index/v3/collections/S2L2A/searchIndex',
  //   minDate: '2017-03-28',
  //   id: 'WILDFIRES',
  //   datasourceID: 'S2L2A',
  //   name: 'WILDFIRES',
  //   typeNames: 'DSS2',
  //   min: 9
  // }
]
const datasources = DATASOURCES,
  customPreset = {
    CUSTOM: {
      name: 'Custom',
      desc: 'Create custom rendering',
      image: 'image.jpg'
    }
  },
  VIEWS = {
    PRESETS: '1',
    BANDS: '2',
    SCRIPT: '3'
  }

export default {
  noCredentials: SENTINEL_2_L1C === '' && LANDSAT_8_API_KEY === '' && MODIS_API_KEY === '',
  customPreset,
  layers: {
    r: 'B04',
    g: 'B03',
    b: 'B02'
  },
  activeDatasource: {...DATASOURCES[0]},
  startLocation: '',
  doRefresh: true,
  activeBaseLayer: {
    name: '',
    minmax: { min: 0, max: 16 }
  },
  evalscripturl: '',
  isLoaded: true,
  lat: 37.98193004253442,
  lng: 23.678009037394077,
  zoom: 12,
  size: [0, 0],
  priority: 'mostRecent',
  mosaic: 'mostRecent',
  evalscript: '',
  renderedEvalscript: '',
  opacity: 100,
  maxcc: 20,
  imgWmsUrl: '',
  mapBounds: {},
  minDate: '2015-01-01',
  maxDate: moment(),
  selectedDate: moment().add(-1,'days'),
  dateFormat: 'YYYY-MM-DD',
  availableDays: [],
  datesCcMap: {},
  onDayPicked: false,
  prevDate: null,
  nextDate: null,
  showDates: false,
  preset: null,
  currView: VIEWS.PRESETS,
  channels: [],
  path: '',
  presets: {
    customPreset
  },
  presetsLegend: [],
  atmFilter: '',
  cloudCorrection: 'none',
  gain: new Number(1).toFixed(1),
  gamma: new Number(1).toFixed(1),
  legendVisible: false,
  devMode: false,
  selectedDevToolsTab: 1,
  devModalVisible: false,
  legendX: 0,
  legendY: 0,
  legendHeight: 0,
  legendWidth: 0,
  legendUrl: null,
  views: VIEWS,
  datasources
}



// WEBPACK FOOTER //
// ./src/store/config.js